import { WebpackBackend } from 'i18next-webpack-backend'

export class MandaaWebpackBackend extends WebpackBackend {
  static type: 'backend' = 'backend';
}
